"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAPI = void 0;
var collection_constants_1 = require("./collection.constants");
var api_client_1 = __importDefault(require("../api-client"));
var CollectionAPI = /** @class */ (function () {
    function CollectionAPI() {
    }
    CollectionAPI.create = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.CREATE, data);
    };
    CollectionAPI.update = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.UPDATE, data);
    };
    CollectionAPI.publish = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.PUBLISH, data);
    };
    CollectionAPI.fetchById = function (id) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_INFO, { id: id });
    };
    CollectionAPI.fetchByIds = function (ids) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_INFO_BY_IDS, { ids: ids });
    };
    CollectionAPI.fetchAllCollections = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_ALL, data);
    };
    CollectionAPI.fetchMyCollections = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_MINE, data);
    };
    CollectionAPI.fetchCollectionsByUser = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_BY_USER, data);
    };
    CollectionAPI.fetchHotCollections = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_HOT, data);
    };
    CollectionAPI.fetchHighlights = function (payload) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.HIGHLIGHTS, payload);
    };
    CollectionAPI.search = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.SEARCH, data);
    };
    CollectionAPI.fetchByFilter = function (data) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_BY_FILTER, data);
    };
    CollectionAPI.fetchStatistics = function (ids) {
        return api_client_1.default.post(collection_constants_1.COLLECTION_API_URLS.GET_STATISTICS, { ids: ids });
    };
    return CollectionAPI;
}());
exports.CollectionAPI = CollectionAPI;
